import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    CanActivate,
    CanActivateChild,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { Observable } from "rxjs";
import { UserService } from "../user.service";

@Injectable()
export class LocationAuth implements CanActivate, CanActivateChild {
    private projectId: number = 0;

    constructor(private router: Router, private service: UserService) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        this.projectId = +route.params["projectId"];
        return this.isAllowedAccess(route, this.projectId);
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | Promise<boolean> | boolean {
        this.projectId = +childRoute.params["projectId"];
        return this.isAllowedAccess(childRoute, this.projectId);
    }

    private async isAllowedAccess(
        route: ActivatedRouteSnapshot,
        projectId: number
    ): Promise<boolean> {
        let returnVal = false;
        let section = route.data.type;

        try {
            var result = await this.service.canAccessLocation(
                section,
                projectId
            );

            let allowAccess = false;

            if (!result) allowAccess = false;
            else if (
                route.data.securityLevel == "Edit" &&
                result.activity != "Edit"
            )
                allowAccess = false;
            else allowAccess = true;

            if (!allowAccess) this.router.navigateByUrl("/unauthorized");

            returnVal = allowAccess;
        } catch {
            this.router.navigateByUrl("/unauthorized");
        }

        return returnVal;
    }
}
